import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

async function parseResponse(response, fallbackMessage) {
  const payload = await response.json().catch(() => null);

  if (!response.ok || payload?.success !== true) {
    return {
      success: false,
      data: null,
      message: payload?.message || fallbackMessage,
      code: payload?.code || "",
    };
  }

  return {
    success: true,
    data: payload?.data ?? null,
    message: payload?.message ?? "",
    code: payload?.code ?? "",
  };
}

export async function getOrganizationNotices({ organizationId, limit } = {}) {
  try {
    const query = new URLSearchParams();
    if (organizationId) query.set("organization_id", organizationId);
    if (limit) query.set("limit", String(limit));

    const response = await authFetch(
      `${BACKEND_URL}/organization/notices?${query.toString()}`,
      { method: "GET" },
    );

    return parseResponse(response, "조직 공지사항 목록을 불러오지 못했습니다.");
  } catch (error) {
    console.error("[getOrganizationNotices] failed:", error);
    return {
      success: false,
      data: null,
      message: "조직 공지사항 목록을 불러오지 못했습니다.",
    };
  }
}

export async function getOrganizationNoticeDetail(noticeId) {
  try {
    const response = await authFetch(
      `${BACKEND_URL}/organization/notices/${encodeURIComponent(noticeId)}`,
      { method: "GET" },
    );

    return parseResponse(response, "조직 공지사항을 불러오지 못했습니다.");
  } catch (error) {
    console.error("[getOrganizationNoticeDetail] failed:", error);
    return {
      success: false,
      data: null,
      message: "조직 공지사항을 불러오지 못했습니다.",
    };
  }
}

export async function createOrganizationNotice({ organizationId, title, body }) {
  try {
    const response = await authFetch(`${BACKEND_URL}/organization/notices`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        organization_id: organizationId,
        title,
        body,
      }),
    });

    return parseResponse(response, "조직 공지사항을 작성하지 못했습니다.");
  } catch (error) {
    console.error("[createOrganizationNotice] failed:", error);
    return {
      success: false,
      data: null,
      message: "조직 공지사항을 작성하지 못했습니다.",
    };
  }
}

export async function updateOrganizationNotice({ noticeId, title, body }) {
  try {
    const response = await authFetch(
      `${BACKEND_URL}/organization/notices/${encodeURIComponent(noticeId)}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ title, body }),
      },
    );

    return parseResponse(response, "조직 공지사항을 수정하지 못했습니다.");
  } catch (error) {
    console.error("[updateOrganizationNotice] failed:", error);
    return {
      success: false,
      data: null,
      message: "조직 공지사항을 수정하지 못했습니다.",
    };
  }
}

export async function deleteOrganizationNotice(noticeId) {
  try {
    const response = await authFetch(
      `${BACKEND_URL}/organization/notices/${encodeURIComponent(noticeId)}`,
      { method: "DELETE" },
    );

    return parseResponse(response, "조직 공지사항을 삭제하지 못했습니다.");
  } catch (error) {
    console.error("[deleteOrganizationNotice] failed:", error);
    return {
      success: false,
      data: null,
      message: "조직 공지사항을 삭제하지 못했습니다.",
    };
  }
}
